export default {
  lang: { en: "English", ko: "한국어", jp: '日本語', es: "Spanish", pt: "Portuguese", zhHant: '繁體中文' },
  "nav": {
    "xwallet": "XWallet",
    "overview": "개요",
    "howToUse": "사용법",
    "userGuide": "유저 가이드",
    "merchantGuide": "가맹점 가이드",
    "faq": "자주묻는 질문"
  },
  "overview": {
    "xwalletNew": {
      "title": "Pundi X의 XWallet",
      "subTitle": "모두를 위한 블록체인의 지갑",
      down: "다운로드",
    },
    "ubiquitous": {
      "title": "원활한 오프라인 및 온라인 블록체인의 거래",
      "subTitle": "XWallet 모바일 앱은 디지털 자산 지갑과 Pundi X 결제 생태계를 연결합니다. 유저가 오프라인 스토어에서 XPOS를 통해 쉽게 결제할 수 있습니다. XWallet은 XPASS와 연결할 수도 있어 언제 어디서나 사용할 수 있는 디지털 결제 앱이 됩니다.",
      list1: "XPOS®를 통해 디지털 자산을 즉시 구입하여 사용",
      list2: "XWallet 내 텔레그램에서 친구와 가족으로부터 디지털 자산을 쉽게 보내고 받으세요. 수수료가 없습니다.",
      list3: "XWallet에서 DApps를 통해 광범위한 서비스 액세스"
    },
    "integration": {
      "title": "완벽한 통합",
      "subTitle": "XWallet에서 디지털 자산을 쉽게 관리하고, 현재 잔액을 확인하거나, 충전할 수 있습니다. 기본적으로 모든 유저는 앱 내 Virtual XPASS 카드를 가지게 됩니다. 또한, 실물 XPASS 카드와 연결하여 필요할 때 앱에서 직접 결제할 수도 있습니다. 연결한 실물 XPASS 카드를 분실한 경우, 모든 토큰을 XWallet 내 다른 XPASS 카드로 전송할 수 있습니다.",
      "wallet": {
        "title": "타 지갑에서 XWallet으로 전송",
        "list1": "\"Card\" 아이콘을 선택하고 Virtual XPASS 카드를 선택합니다.",
        "list2": "충전할 암호화폐 유형을 선택합니다.",
        "list3": "\"Receive\" 아이콘을 누르고 \"View address\"를 선택합니다.",
        "list4": "전송을 받을 지갑 주소를 복사하거나 QR 코드를 스캔합니다.",
        "list5": "타 지갑에서도 올바른 유형의 암호화폐를 선택하고 XWallet 주소로 전송하십시오.",
        "note": "(참고: 토큰을 타 지갑에서 XWallet 앱으로 전송하는 속도는 해당 블록체인 네트워크 상태에 따라 다릅니다. XPOS 가맹점에서 즉시 결제 거래를 하려면 앱을 사용하기 최소 6시간 전에 다른 지갑에서 XWallet으로 전송할 것을 권장합니다.)"
      }
    },
    "payments": {
      "title": "온오프라인 즉시 결제",
      "subTitle": "온라인 XWallet 또는 XPASS를 통한 거래는 즉시 처리될 수 있으며, 오프라인 상태에서는 QR 코드를 스캔하여 나중에 블록체인에 업로드될 수 있습니다. 즉, XWallet은 여러분의 바쁜 생활 방식을 따라잡을 수 있습니다."
    },
    "security": {
      title: "안전 및 보안",
      subTitle:
        "Each XWallet comes with a username and password protection feature. There is also no need for (private key) data backup because it is not a cold wallet. The app can also help users easily retrieve data stored on any phone, device, or XPASS linked to the app.",
      list1: "2FA 지원",
      list2: "개인 키를 소유하는 옵션 제공",
      list3: "생체 보안 잠금 지원"
    },
    "token": {
      "title": "f(x) tokens 스테이킹 안내 : NPXS/NPXSXEM",
      "subtitle": "2019년 3월 20일부터 2020년 3월 19일",
      "linkBtn": "더 알아보기",
      "link": "https://medium.com/pundix/f-x-tokens-%EC%8A%A4%ED%85%8C%EC%9D%B4%ED%82%B9-%EC%95%88%EB%82%B4-npxs-npxsxem-5afb3f4c66d1"
    },
    "convert": {
      "title": "NPXS/NPXSXEM f(x) 변환 가이드",
      "subtitle": "2019년 4월 16일부터 7월 14일까지",
      "linkBtn": "더 알아보기",
      "link": "https://medium.com/pundix/npxs-npxsxem%EC%9D%98-fx-%EB%B3%80%ED%99%98-%EA%B0%80%EC%9D%B4%EB%93%9C-d02458aa7b68"
    },
    privateWallet: {
      title: "여러 개인 지갑 기능 사용 가능",
      list1: "XWallet의 비관리 옵션으로 디지털 자산 제어",
      list2: "개인 지갑: 바이낸스 블록체인 월렛, 삼성 블록체인 월렛, MEW 기반의 펀디엑스 저축 지갑",
      list3: "MEWConect 지원",
      subTitle: "튜토리얼 보기",
      tutorial1: "바이낸스 체인 지갑을 만드는 방법",
      tutorial2: "MEW(Android)로 구동되는 Pundi X Savings Wallet을 생성하는 방법",
      tutorial3: "XWallet(Android)에서 MEW 지갑을 복원하는 방법"
    },
    dapps: {
      title: "디앱스",
      desc: "XWallet 내에서 사용할 수 있는 다양한 DApps 기능으로 디지털 자산 관리, 전송 또는 확장",
      remark: "XWallet에서 DApps 탐색 시작"
    },
    telegramChat: {
      title: "텔레그램 지원",
      list1: "텔레그램으로 친구 및 가족과 대화",
      list2: "크립토 기프트 기능으로 디지털 자산 즉시 전송",
      tutorial1: "텔레그램 계정에 연결하는 방법",
      tutorial2: "크립토 기프트 발송 방법",
      tutorial3: "크립토 기프트 받는 방법"
    },
    manageAssets: {
      title: "디지털 자산을 쉽게 관리 및 확장",
      list1: "XPASS 카드를 XWallet과 페어링하여 디지털 자산 관리 개선",
      list2: "여러 XPASS 카드 간에 디지털 자산을 원활하게 이동",
      list3: "XWallet 사용자 간에 수수료 없이 즉시 디지털 자산 전송 및 수신",
      list4: "XWallet의 다양한 Dapp 및 기능을 통해 디지털 자산 확장",
      subTitle: '튜토리얼 보기',
      tutorial1: "XWallet 내에서 디지털 자산을 전송하는 방법"
    }
  },
  "howToUse": {
    "title": "사용법",
    "subTitle": "XWallet by Pundi X",
    "sect1": {
      "title": "XWallet을 충전하는 방법",
      "htuArr1": {
        "title": "디지털 자산을 XWallet으로 전송하기",
        "li1": "1. \"Card\"를 누르고 Virtual Card를 선택합니다.",
        "li2": "2. 충전할 암호화폐 유형을 선택합니다.",
        "li3": "3. \"Receive\" 아이콘을 누르고 \"View Address\"를 선택합니다.",
        "li4": "4. Top-up 주소를 복사하거나 QR 코드를 스캔합니다.",
        "li5": "5. 다른 지갑에서 올바른 유형의 암호화폐를 선택하고 XWallet Top-up 주소를 기입하여 전송하시면 됩니다."
      },
      "htuArr2": {
        "title": "XPASS 카드에서 XWallet으로 토큰 전송하기",
        "li1": "1. XWallet 앱에 XPASS 카드를 추가합니다.",
        "li2": "2. 토큰을 전송할 XPASS 카드를 누릅니다.",
        "li3": "3. 전송할 암호화폐 유형을 선택합니다.",
        "li4": "4. 오른쪽 상단에 있는 \"...\" 아이콘을 누르고 \"Internal transfer\"을 선택합니다.",
        "li5": "5. 토큰을 전송할 XPASS 카드를 선택합니다.",
        "li6": "6. 토큰의 양을 입력하고 \"Confirm\" 버튼을 클릭합니다.\""
      }
    },
    "sect2": {
      "title": "XWallet에서 외부 주소로 토큰을 전송하는 방법",
      "li1": "1. 토큰을 전송할 카드를 선택하십시오.",
      "li2": "2. 전송할 암호화폐 유형을 선택하십시오.",
      "li3": "3. \"Transfer\" 아이콘을 누르고 수신자의 지갑 주소를 입력하십시오. 블록체인의 불변성으로 인해 거래가 취소될 수 없으므로 주소를 꼭 재확인하시기 바랍니다.",
      "li4": "4. \"Next\"를 눌러 트랜잭션을 완료하십시오."
    }
  },
  "userGuide": {
    "title": "XWallet 유저 가이드",
    "subTitle": "XWallet by Pundi X",
    "sect1": {
      "title": "1. XWallet Virtual Card는 무엇입니까?",
      "desc": "XWallet의 각 사용자는 XWallet의 개인 잔액 계정으로 물리적 카드에 묶이지 않은 원래 Virtual Card 계정을 가집니다. XPASS 카드를 소지하신 경우, 이 페이지 왼쪽 상단에 있는 아이콘 \"+\"를 눌러 XWallet에 추가하실 수 있습니다.",
      "imgAlt": "펀디엑스 가상 카드 계좌"
    },
    "sect2": {
      "title": "2. 가맹점 XWallet에 코인으로 결제하는 방법",
      "li1": "유저 앱에서 \"Scan\"을 클릭합니다.",
      "li2": "가맹점 소유의 수집 QR 코드를 스캔합니다.",
      "li3": "해당 USDT 금액(1 USDT=1 USD)을 입력하십시오.",
      "li4": "충분한 잔액이 있는 카드와 올바른 코인을 선택하십시오.",
      "imgAlt1": "가맹점에게 결제합니다.",
      "imgAlt2": "결제 완료"
    },
    "sect3": {
      "title": "3. 가맹점 XPOS에 코인으로 결제하는 방법",
      "li1": "유저 앱에서 \"Pay\"를 클릭합니다.",
      "li2": "가맹점에게 유저 결제 QR 코드를 보여주시면 XPOS로 코드를 스캔하여 트랜잭션을 완료할 수 있도록 합니다.",
      "li3": "가맹점은 결제 코드 페이지에서 선택한 코인에 따라 수집 방법을 설정합니다.",
      "li4": "잔액이 부족하면 다른 코인으로 지불을 완료하셔야 합니다.",
      "imgAlt": "결제 코드 보기"
    },
    "sect4": {
      "title": "4. 가맹점 환불 신청은 어떻게 하나요?",
      "li1": "구매하신 상품을 환불하기 원하십니까? 가능한 한 빠르게 가맹점에 연락하여 환불을 요청하셔야 합니다. 환불 요청은 가맹점의 환불 정책에 따라 결정됩니다.",
      "li2": "거래 후 30분 이내에 환불 요청이 시작되면 가맹점은 XWallet에서 환불 요청을 완료할 수 있습니다.",
      "li3": "현재 시스템은 거래 후 30분 이내에만 환불을 지원합니다. 30분 후 환불 요청이 있을 경우, XWallet으로 할 수 없기 때문에 가맹점에 수동 환불 절차를 문의해주시기 바랍니다.",
      "imgAlt1": "환불 트랜잭션 찾기",
      "imgAlt2": "환불 완료 세부 내역"
    },
    "sect5": {
      "title": "5. XWallet의 \"Collect\" 기능을 어떻게 사용하나요?",
      "li1": "XWallet 계정 간의 자금 이체는 \"Collect\" 아이콘을 눌러 완료할 수 있습니다.",
      "li2": "앱에서 \"Collect\"를 누르고 수집 코드를 저장하면 다른 사용자가 이 코드를 사용하여 암호를 전송할 수 있습니다.",
      "li3": "참고: XWallet 계정 간 이체는 수수료 없이 즉시 완료됩니다.",
      "imgAlt1": "개인 수집 페이지",
      "imgAlt2": "개인 수집 페이지"
    },
    "sect6": {
      "title": "6. XWallet 계정에서 다른 지갑/교환 주소로 옮기는 방법",
      "li1": "홈페이지에서 \"Transfer\"를 누릅니다.",
      "li2": "옮기시려는 코인을 선택하세요.",
      "li3": "수취인 지갑 주소와 보낼 수량을 입력하시기 바랍니다.",
      "li4": "전송을 컨펌합니다.",
      "li5": "전송 후, 블록체인 네트워크에서 결제가 완료가 확인될 때까지 기다려주시기 바랍니다.",
      "note": "참고: 반드시 올바른 주소를 입력하시기 바랍니다. 블록체인 트랜잭션상 잘못된 주소로 전송한 경우 코인을 복구할 수 없습니다.",
      "imgAlt": "NPXS 전송"
    },
    "sect7": {
      "title": "7. XWallet으로 코인을 전송받거나 입금하는 방법",
      "li1": "전송받을 코인을 선택합니다.",
      "li2": "\"Receive\"을 누르고 \"View address\"를 선택합니다.",
      "li3": "주소를 복사하거나 QR 코드를 스캔합니다.",
      "imgAlt1": "NPXS 계정",
      "imgAlt2": "NPXS 받는 주소"
    },
    "sect8": {
      "title": "8. XWallet에서 Extra 토큰을 어떻게 받을 수 있습니까?",
      "desc": "XWallet은 \"Extra\" 페이지를 수시로 업데이트하여 사용자에게 펀디엑스 프로젝트 기능, 업데이트 및 마일스톤을 충분히 인지할 수 있도록 합니다. 이를 통해 사용자는 작업을 완료하고 토큰을 얻을 수 있습니다. 자세한 내용은  \"Extra\" 페이지로 이동하여 작업에 대한 가이드를 확인하시기 바랍니다.",
      "imgAlt": "Extra 페이지"
    },
    "sect9": {
      "title": "9. 받은 토큰을 어떻게 인출합니까?",
      "li1": "토큰이 인출 한도까지 도달한 경우에만 BTC, ETH, NPXS 및 기타 암호화폐를 인출하실 수 있습니다.",
      "li2": "BTC, ETH, NPXS 또는 기타 토큰이 자동으로 가상 카드(Virtual Card) 계정으로 전송됩니다.",
      "imgAlt": "NPXS 토큰 출금"
    },
    "sect10": {
      "title": "10. XWallet에서 바우처 어떻게 등록할 수 있습니까?",
      "desc": "XWallet은 때때로 사용자에게 바우처를 배포하는 경우가 있습니다. Extra 섹션 아래의 \"My Vouchers\"에서 받은 바우처를 확인하실 수 있습니다. XWallet 가맹점에서 사용하실 수 있습니다. 결제당 1장만 가능합니다.",
      "imgAlt1": "나의 바우처(쿠폰)",
      "imgAlt2": "바우처(쿠폰) 사용"
    },
    "sect11": {
      "title": "11. XWallet 암호를 변경하거나 찾을 수 있습니까?",
      "li1": "홈페이지에서 오른쪽 상단 사람 모양 아이콘을 클릭합니다.",
      "li2": "\"Settings\" - \"Security\"로 이동합니다.",
      "li3": "\"Change login password\" 또는 \"Change payment password\"를 클릭합니다.",
      "li4": "암호를 잊어버린 경우에도 암호를 찾을 수 있습니다.",
      "imgAlt1": "\"Me\" 페이지",
      "imgAlt2": "계정 보안 페이지"
    },
    "sect12": {"title": "12. XWallet 지원", "email": "이메일: xwallet@pundix.com", "tg": "텔레그램:"}
  },
  "merchantGuide": {
    "title": "XWallet 가맹점 가이드",
    "subTitle": "XWallet by Pundi X",
    "sect1": {"title": "1. XWallet 가맹점 신청 방법은 무엇입니까?", "p1": "신청은 다음 링크에서 가능합니다."},
    "sect2": {
      "title": "2. 가맹점으로서 \"Collect\" 기능을 사용하는 방법은 무엇인가요?",
      "p1": "XWallet 가맹점 신청서를 제출한 후 승인이 완료되면, \"Collect\"페이지에서 인증된 가맹점 \"Pundi X verified merchant\"로 표시됩니다.",
      "p2": "XWallet \"Collect\" 페이지에서 고객이 스캔하여 결제할 수 있는 코드를 제시할 수 있습니다.",
      "p3": "\"Collect\" 페이지에서 \"Save\"을 탭하여 QR 코드 이미지를 다운로드하고 인쇄하여 배치 할 수 있습니다. 이것은 지불을 더욱 간편하게 만들 것입니다.",
      "p4": "수집된 암호화폐는 XWallet 가맹점의 가상 카드 계정으로 바로 이동됩니다.",
      "imgAlt1": "가맹점 수집 페이지",
      "imgAlt2": "수집 코드 사진"
    },
    "sect3": {
      "title": "3. USDT로 주문을 받는 방법은 무엇입니까?",
      "p1": "결제 시 USDT를 사용하는 이점은 무엇입니까?",
      "p2": "USDT 결제 중지는 XWallet 판매자가 BTC, ETH, NPXS만 받는 것을 의미합니다. 따라서 가맹점은 가격 변동 및 암호화폐 변동에 상대적으로 많은 영향을 받게됩니다. USDT 결제를 통해 XWallet 가맹점은 모든 자산을 실시간 환율로 USDT로 변환할 수 있습니다. USDT는 가격 변동에 영향을 받지 않는 안정된 가격(1 USDT = 1 USD)을 가집니다.",
      "p3": "USDT 결제를 사용하는 방법은 무엇입니까?",
      "p4": "XWallet 앱의 오른쪽 상단에 있는 사람 모양 아이콘을 누르고 \"Merchant settings\"을 통해 USDT 결제 기능을 사용하실 수 있습니다.",
      "imgAlt1": "USDT 결제",
      "imgAlt2": "USDT 결제 사용"
    },
    "sect4": {
      "title": "4. \"Collection history\"를 확인하는 방법은 무엇입니까?",
      "p1": "\"Collect\"로 이동하여 \"Collection history\"를 찾으시면 현재 트랜잭션과 이전 트랜잭션의 모든 항목을 볼 수 있습니다.",
      "imgAlt": "수집 내역"
    },
    "sect5": {
      "title": "5. 환불을 어떻게 진행할 수 있습니까?",
      "p1": "환불은 \"Collection history\"로 이동하여 취소가 필요한 특정 트랜잭션을 찾은 후 버튼을 눌러 환불할 수 있습니다.",
      "p2": "참고: 환불은 거래가 완료된 후 30분 이내에만 가능합니다. 30분 후 환불 요청은 시스템에서 환불할 수 없습니다.",
      "imgAlt1": "환불 거래 찾기",
      "imgAlt2": "환불 세부 내역"
    },
    "sect6": {
      "title": "6. XWallet 가맹점이 소지하고 있는 USDT를 인출하는 방법은 무엇입니까?",
      "p1": "XWallet 앱을 열고 \"Card\"를 선택합니다.",
      "p2": "USDT 설정으로 이동하여 \"Transfer\"를 누릅니다.",
      "p3": "전송받을 주소 및 금액을 입력합니다.",
      "p4": "입력한 정보를 재확인합니다.",
      "p5": "이후 전송을 진행합니다.",
      "p6": "블록체인 네트워크에서 모든 트랜잭션은 함께 업데이트가 되므로 최종 트랜잭션 결과를 기다려주시기 바랍니다.",
      "imgAlt1": "USDT 계정",
      "imgAlt2": "USDT 인출"
    }
  },
  "faq": {
    "title": "자주묻는 질문", "subTitle": "XWallet by Pundi X", "faqArr": {
      "0": {
        "title": "1. XWallet이란 무엇입니까?",
        "text": {"0": "XWallet은 모바일 디지털 자산 지갑 애플리케이션으로, XPASS 카드의 잔액 관리, 오프라인 코드 스캔을 통한 결제, 모바일 앱 결제 등을 지원합니다."}
      },
      "1": {
        "title": "2. XWallet 앱을 어떻게 다운로드 받을 수 있습니까? XWallet을 실행하기 위한 기본 요건은 무엇입니까?",
        "text": {"0": "Pundi X 공식 사이트에서 XWallet 앱을 다운로드하거나 App Store 혹은 Google Play Store에서 다운로드합니다. XWallet은 Android 4.4 이상에서 실행됩니다. iOS 시스템 10.0 이상에서 실행됩니다."}
      },
      "2": {"title": "3. XPASS 카드를 연결하지 않고 XWallet으로 결제할 수 있습니까?", "text": {"0": "예, 독립적으로 사용할 수 있습니다."}},
      "3": {
        "title": "4. XWallet을 어떻게 충전할 수 있습니까?",
        "text": {
          "0": "XWallet 잔액을 충전하기 위해 다른 지갑에서 XWallet으로 자금을 전송할 수 있습니다.",
          "1": "또한, XPASS 카드를 소지하고 있는 경우 XWallet 앱에 XPASS 카드를 추가할 수도 있습니다."
        }
      },
      "4": {
        "title": "5. XWallet을 통해 XPASS 카드 잔액을 충전하는 방법은 무엇입니까?",
        "text": {
          "0": "XWallet의 잔액을 XPASS 카드에 연결된 자산 주소로 전송할 수 있습니다.",
          "1": "1. 보충할 암호화폐 유형을 선택합니다.",
          "2": "2. 충전할 주소를 복사하거나 QR코드를 스캔합니다.",
          "3": "3. 해당 주소로 올바른 암호화폐를 전송하시면 됩니다."
        }
      },
      "5": {
        "title": "6. XWallet에서 타 지갑의 암호화폐를 전송받는 방법은 무엇입니까?",
        "text": {"0": "XWallet이 지원하는 암호화폐 유형을 선택하신 후, 타 지갑에서 XWallet의 해당 주소로 전송하시면 됩니다."}
      },
      "6": {
        "title": "7. XWallet 자체 주소와 XPASS 카드 주소가 같습니까?",
        "text": {"0": "아니요. 각 XPASS 카드에는 고유의 지갑 주소가 있습니다. XWallet과 별개의 주소이므로 꼭 확인하시기 바랍니다."}
      },
      "7": {
        "title": "8. XWallet에서 지원하는 통화는 무엇입니까?",
        "text": {"0": "출시 버전에는 BTC, ETH, BNB, NPXS 4개의 통화로 지원됩니다. 업데이트가 진행되면 지원되는 암호화폐의 범위도 크게 확장될 것입니다."}
      },
      "8": {
        "title": "9. XWallet의 비밀번호를 설정하려면 어떻게 해야 합니까?",
        "text": {"0": "XWallet에 등록할 때, 로그인 암호와 결제 암호를 설정하게 됩니다. XWallet 설정에서 해당 비밀번호를 변경하실 수도 있습니다."}
      },
      "9": {
        "title": "10. XWallet 비밀번호를 잊어버린 경우 어떻게 해야 합니까?",
        "text": {"0": "XWallet 설정에서 암호를 직접 찾으시거나 고객서비스 XWallet@pundix.com에 문의하여 도움을 받으실 수 있습니다."}
      },
      "10": {"title": "11. XWallet 데이터를 백업하려면 어떻게 해야 합니까?", "text": {"0": "XWallet은 콜드지갑이 아니므로 백업이 필요하지 않습니다."}},
      "11": {
        "title": "12. 사용하는 휴대폰 외에 다른 휴대폰과 디바이스에서 XWallet 앱에 XPASS 카드를 추가할 수 있습니까?",
        "text": {"0": "XPASS 카드가 XWallet 앱에 연결되면 어느 기기든지 로그인하면 XPASS 카드의 데이터를 확인하실 수 있습니다."}
      },
      "12": {
        "title": "13. XWallet의 디지털 자산을 도난당한 경우 어떻게 해야 합니까?",
        "text": {"0": "XWallet 앱의 보안을 유지하는 것은 펀디엑스 팀에게 가장 중요한 사안입니다. XWallet에서 디지털 자산을 분실하거나 도난당한 경우 즉시 등록 이메일을 통해 XWallet@pundix.com으로 이메일을 보내 주시기 바랍니다. 유저분의 자금이 안전하게 유지될 수 있도록 조사하고 즉시 조치를 취할 것입니다."}
      },
      "13": {"title": "14. XWallet은 NPXS Unlocked Token 배포를 지원합니까?", "text": {"0": "네, 지원합니다."}},
      "14": {
        "title": "15. XWallet 앱에서 계정을 설정할 때 개인키를 사용합니까?",
        "text": {"0": "아니요. XWallet 앱 계정을 설정할 때, 개인키가 아닌 이메일 주소와 휴대폰 번호가 필요합니다."}
      }
    }, "other": "질문에 대한 답변을 찾지 못하셨습니까? 여기에서 더 많은 XWallet FAQ를 보실 수 있습니다."
  }
}